import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';


@Component({
  selector: 'mmu-cookie-buttons',
  templateUrl: './mmu-cookie-buttons.component.html',
  styleUrls: ['./mmu-cookie-buttons.component.scss']
})
export class MmuCookieButtonsComponent implements AfterViewInit {
  @ViewChild('acceptAllButton', { static: true, read: ElementRef })
  private acceptAllButton!: ElementRef;

  ngAfterViewInit(): void {
    // Focus allow all cookies button
    if (this.acceptAllButton.nativeElement) {
      this.acceptAllButton.nativeElement.focus({ preventScroll: true });
    }
  }

  @Output() acceptRequiredCookies = new EventEmitter<void>();
  @Output() acceptAllCookies = new EventEmitter<void>();

  onAcceptRequiredCookies() {
    this.acceptRequiredCookies.emit();
  }

  onAcceptAllCookies() {
    this.acceptAllCookies.emit();
  }
}
